// ============================================================
// 🔒 POLÍTICA DE SENHA (B102 — conformidade CFM 2.454/2026, §6.10.1)
// ============================================================
// Fonte ÚNICA da regra de senha do hepato.app. Endurecimento exigido pela
// governança (lacuna ALTA, mitigação obrigatória antes de 26/08/2026):
// mínimo de 12 caracteres COM complexidade. Aplicada em todo ponto onde uma
// senha é criada/alterada (cadastro, troca, geração de senha temporária).
//
// Critério: ≥ 12 caracteres E pelo menos 3 das 4 classes (maiúscula,
// minúscula, dígito, especial) — comprimento como fator dominante (alinhado à
// orientação moderna), sem exigir as 4 classes de forma draconiana.

export const SENHA_TAMANHO_MINIMO = 12;

export const SENHA_REQUISITOS_TEXTO =
  "Mínimo de 12 caracteres, com pelo menos 3 destes: letra maiúscula, letra minúscula, número e caractere especial.";

/** Quantas das 4 classes de caractere a senha contém. */
function classesPresentes(senha: string): number {
  let n = 0;
  if (/[A-Z]/.test(senha)) n++;
  if (/[a-z]/.test(senha)) n++;
  if (/[0-9]/.test(senha)) n++;
  if (/[^A-Za-z0-9]/.test(senha)) n++;
  return n;
}

/**
 * Valida a força da senha conforme a política do B102.
 * @returns string vazia se válida; mensagem de erro se inválida.
 */
export function validarForcaSenha(senha: string): string {
  if (senha.length < SENHA_TAMANHO_MINIMO) {
    return `A senha deve ter no mínimo ${SENHA_TAMANHO_MINIMO} caracteres`;
  }
  if (classesPresentes(senha) < 3) {
    return "A senha deve combinar pelo menos 3 tipos: maiúsculas, minúsculas, números e caracteres especiais";
  }
  return "";
}

/** Conveniência booleana. */
export function senhaForteOk(senha: string): boolean {
  return validarForcaSenha(senha) === "";
}
